import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage({
    target: '.boxer:not(.ft_link_item .boxer)'
  });

// お問い合わせ用バリデーション
  if (document.body.classList.contains('contact')) {
    topValidation();
  }
  
  // フッターリンクのイベント伝播を停止
  const ftLinkItems = document.querySelectorAll('.ft_link_item a');
  ftLinkItems.forEach(link => {
    link.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });
});

// ハンバーガーメニュー
var hamburger = document.querySelector('.menu-trigger');
var nav = document.querySelector('.nav');
hamburger.addEventListener('click', function () {
  hamburger.classList.toggle('js-open');
  nav.classList.toggle('js-open');
});


// パララックス
var image = document.getElementsByClassName('thumbnail_parallax');
  
  // simpleParallaxを実行
  new simpleParallax(image, {
    scale: 1.4,       // 【重要】動きの大きさ（1.1〜1.5くらい推奨）
    delay: 0.6,       // 【重要】遅延（数値が大きいほどフワッとゆっくり動く）
    orientation: 'up' // 下にスクロールすると画像が上に動く（標準的な挙動）
  });

// パララックス（GSAP ScrollTrigger版）
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// すべてのパララックス要素を処理
document.querySelectorAll('.js-parallax').forEach(el => {
  const bg = el.querySelector('.parallax_bg');

  // PC / SP 判定
  const isSp = window.matchMedia('(max-width: 768px)').matches;

  // 画像切り替え
  const bgPc = el.dataset.bgPc;
  const bgSp = el.dataset.bgSp;
  bg.style.backgroundImage = `url(${isSp ? bgSp : bgPc})`;

  // PC / SP で動きを調整（SPは弱め）
  const moveY = isSp ? '-12%' : '-20%';
  const scrubVal = isSp ? 0.8 : 1.2;

  // 縦方向だけパララックス
  gsap.fromTo(
    bg,
    { y: 0 },
    {
      y: moveY,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        end: 'bottom top',
        scrub: scrubVal
      }
    }
  );
});

// 画像読み込み後に再計算（ズレ防止）
window.addEventListener('load', () => {
  ScrollTrigger.refresh();
});

// タイトルアニメーション
document.querySelectorAll('.cmn_ttl').forEach(ttl => {
  const lead = ttl.querySelector('.cmn_lead');
  const title = ttl.querySelector('.cmn_title');

  if (lead) {
    gsap.fromTo(
      lead,
      { x: -50, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: ttl,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      }
    );
  }

  if (title) {
    gsap.fromTo(
      title,
      { y: 30, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.8,
        delay: 0.2,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: ttl,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      }
    );
  }
});